import { MapRowValue } from '@sg/backend/src/lib/db/getMapOr404'
import { createResource, type Accessor } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../../axios'
import { StateSchema } from '../../lib/core/state/State.type'
import type { StateOnlineId } from '../../lib/core/state/StateOnlineId.type'
import { Nullable } from '../../typescript'

async function fetchMapById(stateId: Nullable<StateOnlineId>): Promise<MapRowValue | null> {
  if (stateId) {
    const response = await backendAxios.get(`/st1/map/${stateId}`)
    const row: MapRowValue = response.data
    // validate row
    row.data = parse(StateSchema, row.data)
    return row as MapRowValue
  }
  return null
}

export default function createMapRowResource(stateId: Accessor<Nullable<StateOnlineId>>) {
  const resource = createResource(stateId, fetchMapById)
  return resource
}
